import { createAsyncThunk } from '@reduxjs/toolkit';

import { DOCUMENT_TYPES } from '@backrs_ui/grow-ui/src/models/models';
import { RootState } from '@backrs_ui/grow-ui/src/redux/store';
import { checkForUserDocument } from '@backrs_ui/grow-ui/src/utils/checkForUserDocument';

export const checkUserResume = createAsyncThunk(
  'user/checkResume',
  async (_, { getState, rejectWithValue }) => {
    const state = getState() as RootState;
    const userId = state.user.user?.id;

    if (!userId) {
      return rejectWithValue('No user ID found');
    }

    const hasResume = await checkForUserDocument(userId, DOCUMENT_TYPES.RESUME);

    return hasResume;
  },
);
